export default __webpack_public_path__ + "3418d5aca66606a6665b485d85cc30de.png";